import { BaseQueryFn } from '@reduxjs/toolkit/dist/query'
import axios, { AxiosRequestConfig, AxiosError } from 'axios'
import { BASE_URL, CMS_URL, FOUNDATION_URL, LMS_URL } from 'Constants'
import { ToastService } from 'Services/toast.service'
import { RootState, store } from '../../app/store'
import { config } from 'config'

export declare interface IApiResponse {
    status?: number | string
    message?: string
    data?: any
}




export const getDefaultHeaders = (headers?: any) => {
    
    const token = store.getState().members.authToken
    const tempHeaders = {
        "Content-Type": "application/json",
        Source: "Web",
        Lang: "EN",
    };
    if (token) {
        return {
            Authorization: `Token ${token}`,
            ...tempHeaders,
            ...headers
        };
    }
    return {
        ...tempHeaders,
        ...headers,
      };
}

export const getFileHeaders = (token: string) => {
    const tempHeaders = { 'Content-Type': 'multipart/form-data', Source: 'Web', Lang: 'EN' }
    if (token) {
        return {
            ...tempHeaders,
            Authorization: `Token ${token}`,
        }
    }
    return tempHeaders
}

export const axiosBaseQuery =
    ({
        baseUrl,
    }: {
        baseUrl: string
    }): BaseQueryFn<
        {
            url: string
            method: AxiosRequestConfig['method']
            body?: AxiosRequestConfig['data']
            params?: AxiosRequestConfig['params']
            headers?: AxiosRequestConfig['headers']
            responseType?: AxiosRequestConfig['responseType']
        },
        unknown,
        unknown
    > =>
        async ({ url, method, body, params, headers, responseType }, api) => {
            try {
                const result = await axios({
                    url: baseUrl + url,
                    method,
                    data: body,
                    params,
                    headers: getDefaultHeaders(headers),
                    responseType,
                })
                if (result.data.status.toString() !== '200' && result.data.status.toString() !== '201' ) {
                    if (result.data.message) {
                        // toast.error(result.data.message)
                        console.log(result.data.message)
                    }
                    throw result.data
                }
                return { data: result.data.data }
            } catch (axiosError) {
                if (axios.isAxiosError(axiosError)) {
                    const err = axiosError as AxiosError
                    if (
                        err.response?.status.toString() === "401" ||
                        err.response?.status.toString() === "403"
                    ) {
                        ToastService.showErrorToast({
                            title:
                                "Unauthorised access. Please restart your journey from "+config.clientlink,
                        });

                    }
                    return {
                        error: {
                            status: err.response?.status,
                            data: err.response?.data || err.message,
                        },
                    }
                } else {
                    const err = axiosError as IApiResponse
                    return {
                        error: {
                            status: err.status,
                            data: err.data,
                            message: err.message,
                        },
                    }
                }
            }
        }

const baseUrlQuery = axiosBaseQuery({
    baseUrl: BASE_URL,
})
const foundationUrlQuery = axiosBaseQuery({
    baseUrl: FOUNDATION_URL,
})

const cmsUrlQuery = axiosBaseQuery({
    baseUrl: CMS_URL,
});
const lmsUrlQuery = axiosBaseQuery({
    baseUrl: LMS_URL,
});




export { baseUrlQuery, foundationUrlQuery, cmsUrlQuery,lmsUrlQuery };
